import { render, staticRenderFns } from "./project-detail.vue?vue&type=template&id=5b5460c0&scoped=true&"
import script from "./project-detail.vue?vue&type=script&lang=js&"
export * from "./project-detail.vue?vue&type=script&lang=js&"
import style0 from "./project-detail.vue?vue&type=style&index=0&id=5b5460c0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5460c0",
  null
  
)

component.options.__file = "project-detail.vue"
export default component.exports